import {
    ChevronDownIcon, ChevronUpIcon,
} from 'components/Icon'
import React, {
    Ref, forwardRef,
} from 'react'
import {
    toggleButton, toggleContentInner, toggleContent as toggleContentStyles, toggleIcon, toggleWrapper,
} from './styles'

import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

interface ToggleViewProps {
  header: (collapsed: boolean) => React.ReactElement | null;
  content: (collapsed: boolean) => React.ReactElement | null;
  collapsed: boolean;
  toggleContent: () => void;
  small: boolean;
}

const ToggleWrapperStyled = styled('div', toggleWrapper)
const ToggleButtonStyled = styled('button', toggleButton)
const ToggleContentStyled = styled('div', toggleContentStyles)
const ToggleContentInnerStyled = styled('div', toggleContentInner)
const ToggleIconStyled = styled('div', toggleIcon)

const ToggleView = forwardRef((props: ToggleViewProps, ref: Ref<HTMLDivElement>) => {
    const {
        header,
        content,
        collapsed,
        small,
        toggleContent,
    } = props

    const {t} = useTranslation()

    return (
        <ToggleWrapperStyled>
            <ToggleButtonStyled
                onClick={toggleContent}
                small={small}
                type='button'
            >
                <div>{header(collapsed)}</div>
                <div>
                    {collapsed ? <ToggleIconStyled small={small}>{small ? '' : t('show')} <ChevronDownIcon /></ToggleIconStyled> : null}
                    {!collapsed && <ToggleIconStyled small={small}>{small ? '' : t('hide')} <ChevronUpIcon /></ToggleIconStyled>}
                </div>

            </ToggleButtonStyled>
            <ToggleContentStyled ref={ref}>
                <ToggleContentInnerStyled>{content(collapsed)}</ToggleContentInnerStyled>
            </ToggleContentStyled>
        </ToggleWrapperStyled>
    )
})

ToggleView.displayName = 'ToggleView'

export default ToggleView
